<h1 mat-dialog-title>Crear nueva tarea</h1>

<mat-dialog-content [formGroup]="form">
  <div class="container">
    <div class="row" style="margin-top: 10px">
      <div class="col-12 col-xl-9">
        <!-- Title -->
        <mat-form-field appearance="outline" class="nobottom">
          <mat-label>Título de la tarea</mat-label>
          <input matInput placeholder="Introduce el título de la tarea..." formControlName="title" />
        </mat-form-field>
      </div>
      <div class="col-12 col-xl-3">
        <!-- Type -->
        <mat-form-field appearance="outline" class="nobottom">
          <mat-label>Tipo</mat-label>
          <mat-select formControlName="type">
            <mat-select-trigger class="selected-task-item">
              <div class="{{ form.value.type }}"></div>
              <div class="task-item-name">{{ form.value.type | productTaskTypeFieldPipe }}</div>
            </mat-select-trigger>
            @for (v of taskTypes; track v) {
              <mat-option [value]="v" [disabled]="isTaskTypeDisabled(v)" [class.task-type-option--restricted]="isTaskTypeDisabled(v)">
                <div
                  class="task-item-option"
                  [matTooltip]="
                    isTaskTypeDisabled(v) ? (data.board_only_issue_message ?? boardOnlyIssueMessage) : (v | productTaskTypeDescriptionPipe)
                  "
                  matTooltipPosition="right"
                >
                  <img class="task-item-icon" [src]="v | productTaskTypeImage" />
                  <span>{{ v | productTaskTypeFieldPipe }}</span>
                </div>
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div
        class="col-12"
        [class.col-xl-6]="filtered_origin_categories.length > 0"
        [class.col-xl-12]="filtered_origin_categories.length === 0"
      >
        <!-- Board -->
        <mat-form-field appearance="outline" class="nobottom">
          <mat-label>Selecciona el tablero</mat-label>
          <mat-select formControlName="company_product_phase_board_id">
            <mat-option value="">Backlog</mat-option>
            @for (board of company_product_phase_boards; track board) {
              <mat-option [value]="board.id">{{ board.title }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      @if (filtered_origin_categories.length) {
        <div class="col-12 col-xl-6">
          <mat-form-field appearance="outline">
            <mat-label>Motivo</mat-label>
            <mat-select formControlName="product_task_origin_category_id">
              @for (ptoc of filtered_origin_categories; track ptoc.id) {
                <mat-option [value]="ptoc.id">{{ ptoc.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          @if (selected_origin_category_description !== '') {
            <p class="mb-0" style="font-size: 12px; margin-top: -8px">
              {{ selected_origin_category_description }}
            </p>
          }
        </div>
      }
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Cancelar</button>
  <button mat-flat-button color="accent" [disabled]="loading || !form.valid" cdkFocusInitial (click)="submit()">
    <mat-icon>check_add</mat-icon>
    Crear nueva tarea
  </button>
</mat-dialog-actions>
